import { UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import type { TodoListCollaboratorResponse } from '@/lib/api';

interface AssignUserButtonProps {
  collaborators: TodoListCollaboratorResponse[];
  currentAssignments: Array<{ userId: string; username: string }>;
  onAssign: (username: string) => void;
  onUnassign: (userId: string) => void;
}

export function AssignUserButton({
  collaborators,
  currentAssignments,
  onAssign,
  onUnassign,
}: AssignUserButtonProps) {
  if (collaborators.length === 0) return null;

  const assignedIds = new Set(currentAssignments.map((a) => a.userId));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 flex-shrink-0"
          title="Assign user"
          aria-label="Assign user"
        >
          <UserPlus className="h-3 w-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-48 p-2" align="end">
        <p className="text-xs font-medium text-muted-foreground mb-2 px-1">Assign to</p>
        {collaborators.map((c) => {
          const isAssigned = assignedIds.has(c.userId);
          return (
            <label
              key={c.userId}
              className="flex items-center gap-2 px-1 py-1.5 rounded hover:bg-muted cursor-pointer"
            >
              <Checkbox
                checked={isAssigned}
                onCheckedChange={(checked) => {
                  if (checked) {
                    onAssign(c.username);
                  } else {
                    onUnassign(c.userId);
                  }
                }}
              />
              <span className="text-sm">{c.username}</span>
            </label>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
